import global from '../global'

const productList = global.serverUrl + '/backstage/product/list'
const productUpdate = global.serverUrl + '/backstage/product/update'

const albumList = global.serverUrl + '/backstage/product/album/list'
const albumKvs = global.serverUrl + '/backstage/product/album/kvs'
const albumGet = global.serverUrl + '/backstage/product/album/get'
const albumUpdate = global.serverUrl + '/backstage/product/album/update'
const albumSave = global.serverUrl + '/backstage/product/album/save'

const cardList = global.serverUrl + '/backstage/product/card/list'
const cardKvs = global.serverUrl + '/backstage/product/card/kvs'
const cardGet = global.serverUrl + '/backstage/product/card/get'
const cardUpdate = global.serverUrl + '/backstage/product/card/update'
const cardSave = global.serverUrl + '/backstage/product/card/save'

const vipList = global.serverUrl + '/backstage/product/vip/list'
const vipGet = global.serverUrl + '/backstage/product/vip/get'
const vipUpdate = global.serverUrl + '/backstage/product/vip/update'
const vipSave = global.serverUrl + '/backstage/product/vip/save'

const capacityList = global.serverUrl + '/backstage/product/param/capacity/list'
const capacityGet = global.serverUrl + '/backstage/product/param/capacity/get'
const capacityUpdate = global.serverUrl + '/backstage/product/param/capacity/update'

const scanList = global.serverUrl + '/backstage/product/param/scan/list'
const scanGet = global.serverUrl + '/backstage/product/param/scan/get'
const scanUpdate = global.serverUrl + '/backstage/product/param/scan/update'

const locationList = global.serverUrl + '/backstage/product/param/location/list'
const locationGet = global.serverUrl + '/backstage/product/param/location/get'
const locationUpdate = global.serverUrl + '/backstage/product/param/location/update'

const mdseKvs = global.serverUrl + '/backstage/product/mdse/kvs'
const mdsePackageKvs = global.serverUrl + '/backstage/product/mdse/package/kvs'

export default {
  productList,
  productUpdate,
  albumList,
  albumKvs,
  albumGet,
  albumUpdate,
  albumSave,
  cardList,
  cardKvs,
  cardGet,
  cardUpdate,
  cardSave,
  vipList,
  vipGet,
  vipUpdate,
  vipSave,
  capacityList,
  capacityGet,
  capacityUpdate,
  scanList,
  scanGet,
  scanUpdate,
  locationList,
  locationGet,
  locationUpdate,
  mdseKvs,
  mdsePackageKvs
}



// WEBPACK FOOTER //
// ./src/config/api/product.js